<template>
    <div class="w-full flex flex-column gap-4">
        <div class="w-full p-2 flex flex-column gap-2">
            <span class="flex text-lg font-medium text-900 mb-3">1. Фотография (селфи)</span>
            <div class="flex gap-4">
                <div class="w-8rem flex-shrink-0"><img alt="Пример селфи"
                        class="w-full border-1 surface-border border-round-lg shadow-1"
                        src="/images/kyc/selfie-example.png"></div>
                <div class="flex-1">
                    <p class="text-sm text-900 mb-2 font-medium">Требования:</p>
                    <ul class="text-sm text-700 flex flex-column gap-1">
                        <li>Лицо полностью в кадре</li>
                        <li>Хорошее освещение</li>
                        <li>Без очков и головных уборов</li>
                        <li>Нейтральный фон</li>
                        <li>Четкое изображение без размытия</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="w-full p-2 flex flex-column gap-2">
            <span class="flex text-lg font-medium text-900 mb-3">2. Паспорт (страницы 2-3)</span>
            <div class="flex gap-4">
                <div class="w-8rem flex-shrink-0"><img alt="Пример паспорта"
                        class="w-full border-1 surface-border border-round-lg shadow-1"
                        src="/images/kyc/passport-example.jpg"></div>
                <div class="flex-1">
                    <p class="text-sm text-900 mb-2 font-medium">Проверьте, чтобы были видны:</p>
                    <ul class="text-sm text-700 flex flex-column gap-1">
                        <li>Все надписи, цифры, отметки</li>
                        <li>Печать органа, выдавшего паспорт</li>
                        <li>Код подразделения</li>
                        <li>Голографический герб РФ на странице 3</li>
                        <li>Горизонтальные линии между страницами 2 и 3</li>
                        <li>Машиночитаемая запись внизу (если паспорт после 2011г)</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="w-full p-2 flex flex-column gap-2">
            <span class="flex text-lg font-medium text-900 mb-3">3. Страница с адресом (страница 5)</span>
            <div class="flex gap-4">
                <div class="w-8rem flex-shrink-0"><img alt="Пример страницы с адресом"
                        class="w-full border-1 surface-border border-round-lg shadow-1"
                        src="/images/kyc/selfie-example.png"></div>
                <div class="flex-1">
                    <p class="text-sm text-900 mb-2 font-medium">Требования к фото:</p>
                    <ul class="text-sm text-700 flex flex-column gap-1">
                        <li>Изображение без бликов</li>
                        <li>Все края документа видны</li>
                        <li>Символы четко различимы</li>
                        <li>Без посторонних предметов и надписей</li>
                        <li>Рукописный адрес регистрации виден очень четко</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="surface-100 border-1 surface-border border-round-lg px-4 py-3">
            <span class="font-medium text-900 mb-2">Общие рекомендации</span>
            <ul class="text-sm text-700 flex flex-column gap-1">
                <li>Форматы файлов: .JPG, .JPEG, .PNG, .GIF</li>
                <li>Максимальный размер: 128 МБ</li>
                <li>Фотографируйте при хорошем освещении</li>
                <li>Избегайте бликов и теней на документах</li>
                <li>Убедитесь, что все данные читаемы</li>
            </ul>
        </div>
    </div>
</template>


<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'KycInfo',
    data() {
        return {
            connect: null,
            helper: null,
        }
    },
    mounted() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}

</script>